// Helpers
import { errorLogger } from "@/Common/helpers/logger";
// Types
import { ExtendedTreeNode } from "@/Washouts/views/Layers/SupportRequests/Sidebar";

export interface IIdsObject {
	commissionCycle: string;
	payPeriod: string;
	position: string;
	user: string;
}

export const parseIdsFromSelectedTreeNode = (selected: ExtendedTreeNode | null, currentUserId: string): IIdsObject => {
	const { ids = {}, levelName } = selected ?? {};

	switch (levelName) {
		case "user": {
			// ReiviewTree
			const { commissionCycle = "", payPeriod: composedPayPeriodId = "", position = "", user: composedUserId = "" } = ids;
			const user = composedUserId.split("_")[2] ?? "";
			const [_ccId, payPeriod] = composedPayPeriodId.split("_");
			return { commissionCycle, payPeriod, position, user };
		}
		case "payPeriod": {
			// MyTree Current/Previous single positions
			const { commissionCycle = "", payPeriod: composedPayPeriodId = "" } = ids;
			const [_ccId, payPeriod, user, position] = composedPayPeriodId.split("_");
			return { commissionCycle, payPeriod, position, user: user ?? currentUserId };
		}
		case "position": {
			// MyTree Current/Previous multiple positions
			const { commissionCycle = "", payPeriod = "", position: composedPositionId = "" } = ids;
			const [_ccId, _ppId, user = "", position = ""] = composedPositionId.split("_") ?? [];
			return { commissionCycle, payPeriod, position, user: user ?? currentUserId };
		}
		default: {
			if (selected) {
				errorLogger(new Error("DAT: Invalid levelName"), {
					message: `The levelName: '${levelName}' was not programmed to be selectable for this tree.`,
				});
			}
			return { commissionCycle: "", payPeriod: "", position: "", user: "" };
		}
	}
};
